import { useState, useEffect } from "react";
import moment from "moment";

function useFilter(state, defaultValue = {}) {
  const [filter, setFilter] = useState(() => {
    try {
      const storedFilter = sessionStorage.getItem("filter");

      const editFilter = findIso8601ValuesInObject(JSON.parse(storedFilter));

      return storedFilter ? editFilter[state] || defaultValue : defaultValue;
    } catch (error) {
      console.error("Error getting filter settings from localStorage", error);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      const globalFilter = sessionStorage.getItem("filter");
      const currentFilter = globalFilter ? JSON.parse(globalFilter) : {};

      const temp = JSON.stringify({ ...currentFilter, [state]: filter });
      sessionStorage.setItem("filter", temp);
    } catch (error) {
      console.error("Error setting filter settings to localStorage", error);
    }
  }, [filter]);

  const resetFilter = () => {
    const currentFilter = JSON.parse(sessionStorage.getItem("filter")) || {};
    delete currentFilter[state];
    sessionStorage.setItem("filter", JSON.stringify(currentFilter));
    setFilter(defaultValue);
  };

  return { filter, setFilter, resetFilter };
}

const regexIso8601 =
  /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;

const findIso8601ValuesInObject = (response) => {
  for (let key in response) {
    let value = response[key];

    if (typeof value !== "object") {
      let match;

      if (typeof value === "string" && (match = value.match(regexIso8601))) {
        value = convertToFormattedDate(value);
        response[key] = value;
      }
    } else {
      findIso8601ValuesInObject(value);
    }
  }

  return response;
};

const convertToFormattedDate = (date) => {
  return moment(date);
};

export default useFilter;
